import React from 'react';
import { observer } from 'src/utils/mobx-react';
import {
    AccountNavLinkWrapper,
    AccountNavText,
    HelpIconWrapper,
} from 'src/domains/players/webview/components/Account/accountPanel/accountNavigation/AccountNavigation.style';
import { UniverseComponent } from 'src/domains/common/universes';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { AccountNavVariantType } from 'src/domains/layouts/config/features/types';

export const FaqLinkNav = observer('FaqLinkNav', () => {
    const common = useCommon();
    const configState = ConfigComponents.get(common).config;
    const { accountNavVariant } = configState.componentVariants;
    return (
        <AccountNavLinkWrapper
            dataTest='account-navigation-help'
            to={{ account: 'static', static: 'help' }}
            routeNameForGtm='help'
            variant={configState.componentVariants.accountNavVariant}
        >
            {accountNavVariant === AccountNavVariantType.SECONDARY ? (
                <UniverseComponent>
                    {(universeModule): React.ReactElement => <universeModule.faqNavIcon />}
                </UniverseComponent>
            ) : (
                <HelpIconWrapper />
            )}

            <AccountNavText variant={accountNavVariant}>
                <UniverseComponent>
                    {(universeVersion): React.ReactElement => <universeVersion.faqLinkNav />}
                </UniverseComponent>
            </AccountNavText>
        </AccountNavLinkWrapper>
    );
});
